// Backend received data can be reformatted when displayed in the table
// Depending on the property/variable, different formatting may be applicable
import { getCountryWithEmoji } from '../../../../shared/contexts/CountryEmojiContext'


export function dataToDisplayFormat({ entry, propt }) {
  switch (propt) {
    case 'corapp_country':
      return getCountryWithEmoji(entry[propt])
    case 'rapp_country':
      return getCountryWithEmoji(entry[propt])
    case 'eu_legal_basis':
      return getEuLegalBasisDescription(entry[propt]);
    case 'ema_procedure_start_initial':
      return slashDateToStringDate(entry[propt]);
    default:
      if (propt.includes('date')) {
      return slashDateToStringDate(entry[propt]);
      }
      if (propt.includes('days')) {
        return formatDaysToYears(entry[propt]);
      }
      return entry[propt]
  }
}

export function formatDaysToYears(value) {
  const days = parseInt(value, 10);

  if (isNaN(days)) {
    return value; // Return original value if not a valid number
  }

  if (days < 365) {
    // Less than a year, display in months
    const months = Math.round(days / 30.4375); // Approximate average days in a month (365.25 / 12)
    return `${days} days (${months} month${months === 1 ? '' : 's'})`;
  } else {
    // One year or more, display in years
    const years = (days / 365).toFixed(1); // One decimal place for years
    return `${days} days (${years} year${years === '1.0' ? '' : 's'})`;
  }
}

export function getEuLegalBasisDescription(value) {
  switch (value) {
    case 'article 8(3)':
      return 'article 8(3) - Full Application';
    case 'article 10(1)':
      return 'article 10(1) - Generic Application';
    case 'article 10(1), article 10(3)':
      return 'article 10(1), article 10(3) - Generic/Hybrid';
    case 'article 10(3)':
      return 'article 10(3) - Hybrid Application';
    case 'article 10(4)':
      return 'article 10(4) - Biosimilar Application';
    case 'article 10a':
      return 'article 10a - Well-Established Use';
    case 'article 10b':
      return 'article 10b - Fixed Combination Application';
    case 'article 10c':
      return 'article 10c - Informed Consent Application';
    default:
      return value; // Return the original value if no specific short name is found
  }
}

export function formatSlashDateToISO(slashDate) {
  // Check if the date is a valid string
  if (typeof slashDate !== 'string' || slashDate.length === 0) {
    return ''; // Return an empty string or null for invalid input
  }

  // Regex to match common slash-separated date formats (MM/DD/YYYY or DD/MM/YYYY)
  // This is a simple regex, more robust solutions might be needed for different locales
  const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (!dateRegex.test(slashDate)) {
    return slashDate; // Return the original value if it doesn't match the expected format
  }

  // Create a new Date object. The Date constructor can handle most slash date formats.
  const dateObj = new Date(slashDate);

  // Check if the date object is valid
  if (isNaN(dateObj.getTime())) {
    return slashDate; // The date is invalid, so return the original string
  }

  // Get year, month, and day
  const year = dateObj.getFullYear();
  // Months are 0-indexed, so add 1
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  // Return the date in YYYY-MM-DD format
  return `${year}-${month}-${day}`;
}

export function slashDateToStringDate(date) {
  const defValue = date

  // Check if the date string matches the expected format (YYYY-MM-DD)
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(date)) {
    return defValue; // Return 'NA' for invalid date formats
  }

  const splittedDate = date.split('-');
  if (splittedDate.length !== 3) {
      return defValue; // return NA if split does not produce 3 parts
  }

  const year = splittedDate[0];
  const monthIndex = parseInt(splittedDate[1], 10) - 1; // Month is 0-indexed
  const day = parseInt(splittedDate[2], 10);

  if (isNaN(monthIndex) || isNaN(day)) {
    return defValue; // return NA if day or month is not a number
  }

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  if (monthIndex < 0 || monthIndex >= months.length) {
    return defValue; // return NA if month index is out of range.
  }

  const month = months[monthIndex];

  const fullDate = day + ' ' + month + ' ' + year;
  return fullDate;
}
